import ListingsAround from './ListingsAround';

export default ListingsAround;
